export const loader = `${process.env.REACT_APP_IMAGE_URL}/loader.webp`;
export const profile = `${process.env.REACT_APP_IMAGE_URL}/profile-icon.png`;
export const arrow = `${process.env.REACT_APP_IMAGE_URL}/left-arrow.svg`;
export const tripleLine = `${process.env.REACT_APP_IMAGE_URL}/menu-icon.png`;
export const exportIcon = `${process.env.REACT_APP_IMAGE_URL}/export.svg`;
export const loginLogo = `${process.env.REACT_APP_IMAGE_URL}/logo.png`;
export const actionIcon = `${process.env.REACT_APP_IMAGE_URL}/action.svg`;
export const rightArrow = `${process.env.REACT_APP_IMAGE_URL}/arrow-right.svg`;
export const textHighlight = `${process.env.REACT_APP_IMAGE_URL}/backgroundColorImageLogin.svg`;
export const loginFrameLogo = `${process.env.REACT_APP_IMAGE_URL}/login-background-image.png`;
export const addIcon = `${process.env.REACT_APP_IMAGE_URL}/add-icon.svg`;
export const minusIcon = `${process.env.REACT_APP_IMAGE_URL}/minus-icon.svg`;
export const closeIcon = `${process.env.REACT_APP_IMAGE_URL}/close.svg`;
export const defaultImage = `${process.env.REACT_APP_IMAGE_URL}/default-image.png`;
export const arrowUpIcon = `${process.env.REACT_APP_IMAGE_URL}/arrow-up.svg`;
export const editIcon = `${process.env.REACT_APP_IMAGE_URL}/editIcon.svg`;
export const vector = `${process.env.REACT_APP_IMAGE_URL}/vector.svg`;
export const leftArrowIcon = `${process.env.REACT_APP_IMAGE_URL}/arrow-left.svg`;
export const trashOutlineIcon = `${process.env.REACT_APP_IMAGE_URL}/trash.svg`;
export const arrowDownIcon = `${process.env.REACT_APP_IMAGE_URL}/vector.svg`;
export const mailIcon = `${process.env.REACT_APP_IMAGE_URL}/mailIcon.svg`;
export const phoneIcon = `${process.env.REACT_APP_IMAGE_URL}/call.svg`;
export const mapPinMarker = `${process.env.REACT_APP_IMAGE_URL}/mapPinMarker.svg`;
export const deliveryIcon = `${process.env.REACT_APP_IMAGE_URL}/locationIcon.svg`;
export const infoIcon = `${process.env.REACT_APP_IMAGE_URL}/infoIcon.svg`;
export const noteIcon = `${process.env.REACT_APP_IMAGE_URL}/note.svg`;
export const notFound = `${process.env.REACT_APP_IMAGE_URL}/not-found.svg`;
export const tickSquareActive = `${process.env.REACT_APP_IMAGE_URL}/tickSquareActive.svg`;
export const addingIcon = `${process.env.REACT_APP_IMAGE_URL}/addIcon.svg`;
export const subtractIcon = `${process.env.REACT_APP_IMAGE_URL}/minusIcon.svg`;
export const rightArrowIcon = `${process.env.REACT_APP_IMAGE_URL}/right-arrow.svg`;
export const logo = `${process.env.REACT_APP_IMAGE_URL}/images/logo.png`;
